import { render, staticRenderFns } from "./EditableTexts.vue?vue&type=template&id=56772a5b&scoped=true"
import script from "./EditableTexts.vue?vue&type=script&lang=js"
export * from "./EditableTexts.vue?vue&type=script&lang=js"
import style0 from "./EditableTexts.vue?vue&type=style&index=0&id=56772a5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56772a5b",
  null
  
)

export default component.exports